import { Callout } from '@liveauctioneers/hammer-ui-core/callout';
import { ReactNode } from 'react';

type Props = {
    message: ReactNode;
};

export const ExpiredCheckoutMessage = ({ message }: Props) => {
    return (
        <Callout
            className="mb-sm"
            message={message}
            status="critical"
        />
    );
};
